export default {
    texts: {
        Dashboard: 'Dashboard',
        Customers: 'Clientes',
        ERP: 'ERP',
        Colors: 'Cores',
        Commissions: 'Comissões',
        Prospects: 'Prospects',
        Contents: 'Conteúdos',
        Certificates: 'Certificados digitais',
        Settings: 'Configurações',
        Users: 'Usuários',
        Email: 'E-mail',
        Empresa: 'Empresa',
        Contatos: 'Contatos',
        Modules: 'Módulos',
        Bills: 'Faturas',
        Roles: 'Perfis de Usuários',
        Files: 'Materiais de Apoio',
        Support: 'Suporte',
        'Help Center': 'Central de Ajuda',
        'Help Me': 'Solicitar Suporte',
        'Bank Accounts': 'Contas Bancárias',
        Addresses: 'Endereços',
        Categories: 'Categorias',
        Marketing: 'Marketing',
        'Landing Pages': 'Páginas de Captação',
        Integrations: 'Integrações',
        Mails: 'E-mails',
        Tickets: 'Meus Chamados',
    },
}
